import React, { useState } from "react";
import { FaCompress, FaExpand, FaMapMarkedAlt } from "react-icons/fa";

import "./MapViewportToolbar.css";

function MapViewportToolbar({
  onSave,
  disabled = false,
  label = "Salvar posição do mapa",
  savingLabel = "Salvando...",
  className = "",
  cleanMode = false,
  onToggleClean,
  cleanLabel = "Tela limpa",
  exitCleanLabel = "Sair da tela limpa",
}) {
  const [saving, setSaving] = useState(false);

  async function handleSave() {
    if (!onSave || saving || disabled) return;
    setSaving(true);
    try {
      await onSave();
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className={`map-viewport-toolbar ${className}`.trim()}>
      <button
        type="button"
        className="btn btn-default btn-sm map-viewport-toolbar__button"
        onClick={handleSave}
        disabled={disabled || saving}
        title={label}
      >
        <FaMapMarkedAlt style={{ marginRight: 6 }} />
        {saving ? savingLabel : label}
      </button>
      {onToggleClean ? (
        <button
          type="button"
          className="btn btn-default btn-sm map-viewport-toolbar__button"
          onClick={onToggleClean}
          title={cleanMode ? exitCleanLabel : cleanLabel}
          aria-label={cleanMode ? exitCleanLabel : cleanLabel}
        >
          {cleanMode ? <FaCompress /> : <FaExpand />}
        </button>
      ) : null}
    </div>
  );
}

export default MapViewportToolbar;
